import { lazyLoad } from "utils";

export const IndividualsPageLazy = lazyLoad(
  () => import("./individuals"),
  (module) => module.IndividualsPage
);

export const IndividualDetailsMainPageLazy = lazyLoad(
  () => import("./individual-details"),
  (module) => module.IndividualDetailsMainPage
);

export const IndividualAccountViewTransactionDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/account/view-transaction-details"
    ),
  (module) =>
    module.IndividualAccountViewTransactionsDetailsPage as React.ComponentType<any>
);

export const IndividualTransactionsViewTransactionDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/transactions/view-transaction-details"
    ),
  (module) =>
    module.IndividualTransactionsViewTransactionDetailsPage as React.ComponentType<any>
);

export const IndividualAccountTransactionDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/account/view-account-transactions"
    ),
  (module) => module.AccountTransactionsPage
);

export const IndividualViewLoanDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/loans/view-loan-details"
    ),
  (module) => module.LoanDetailsPage as React.ComponentType<any>
);

export const IndividualViewSavingDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/savings/view-saving-details"
    ),
  (module) => module.SavingDetailsPage as React.ComponentType<any>
);

export const IndividualViewSavingsHistoryPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/savings/view-savings-history"
    ),
  (module) => module.SavingsHistoryPage as React.ComponentType<any>
);

export const IndividualViewWithdrawalHistoryPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals/individual-details/content/on-demand-pay/view-withdrawal-history"
    ),
  (module) => module.WithdrawalHistoryPage as React.ComponentType<any>
);
